// import { Component, Inject } from '@angular/core';
// import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// @Component({
//   selector: 'app-ver-img',
//   templateUrl: './ver-img.component.html',
//   styleUrls: ['./ver-img.component.scss']
// })
// export class VerImgComponent {
//   constructor(
//     public dialogRef: MatDialogRef<VerImgComponent>,
//     @Inject(MAT_DIALOG_DATA) public data: { imageUrl: string }
//   ) {}

//   closeDialog(): void {
//     this.dialogRef.close();
//   }
// }

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface Image {
  url: string;
  title: string;
}

@Component({
  selector: 'app-ver-img',
  templateUrl: './ver-img.component.html',
  styleUrls: ['./ver-img.component.scss']
})
export class VerImgComponent {
  currentIndex: number = 0;
  images: Image[] = [];
  zoomed: boolean = false; // Controla si la imagen está acercada o no

  constructor(
    public dialogRef: MatDialogRef<VerImgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.currentIndex = data.currentIndex;
    // Configura las imágenes y sus títulos
    this.images = [
      { url: data.url, title: 'Vista principal' },
      { url: data.url_back, title: 'Vista trasera' },
      { url: data.url_side, title: 'Vista lateral' },
      { url: data.url_file_opt1, title: 'Archivo opción 1' },
      { url: data.url_file_opt2, title: 'Archivo opción 2' },
    ].filter(image => image.url); // Filtra imágenes nulas
  }

  // Navegar a la imagen anterior
  prevImage(): void {
    this.currentIndex =
      this.currentIndex === 0 ? this.images.length - 1 : this.currentIndex - 1;
  }

  // Navegar a la siguiente imagen
  nextImage(): void {
    this.currentIndex =
      this.currentIndex === this.images.length - 1 ? 0 : this.currentIndex + 1;
  }

  toggleZoom(): void {
    this.zoomed = !this.zoomed; // Alterna entre acercado y tamaño normal
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
